<template>
    <section
        class="p-list"
        ref="list">
        <section
            v-if="mapPoints && viewMode === 'view-map'"
            class="p-list__map">
            <Map
                :map-data="mapPoints"
                @show-form="showFormFeedback" />
        </section>
        <section
            v-if="viewMode !== 'view-map'"
            class="p-list__list"
            :class="viewMode">
            <template
                v-for="item in getData"
                :key="item.id">
                <offer-card
                    v-if="item.active === 'Y'"
                    :card-data="item"
                    :is-mobile="isMobile"
                    :class="viewMode"
                    @offer-chosen="showFormFeedback"
                    @add-to-favorite="showFavoriteWarn = true" />
            </template>
            <div class="p-list__empty-card"></div>
        </section>
        <pagination
            v-if="!isMobile && viewMode !== 'view-map'"
            :current-page="offersData.nav.NavPageNomer"
            :total-pages="offersData.nav.NavPageCount"
            @update-data="paginationHandler" />
        <button
            v-if="showMoreBtn && viewMode !== 'view-map'"
            class="p-list__show-more"
            @click.prevent="showMoreHandler">
            Показать еще
        </button>
    </section>

    <Transition>
        <form-feedback
            v-if="formFeedbackVisible && currentOffer"
            :offer="currentOffer"
            @hide-modal="hideFeedbackForm" />
    </Transition>
    <favorite-warn
        v-if="showFavoriteWarn"
        @hide-warn="showFavoriteWarn = false" />
</template>

<script>
    import OfferCard from './OfferCard'
    import Map from './Map'
    import Pagination from './Pagination'
    import FormFeedback from './FormFeedback'
    import FavoriteWarn from './FavoriteWarn'

    import URLHelper from '../../../modules/URLHelper'
    import scrollIt from '../../../modules/scroll-it';

    export default {
        name: 'List',
        components: {
            OfferCard,
            Map,
            Pagination,
            FormFeedback,
            FavoriteWarn
        },
        props: {
            offersData: {
                type: Object,
                default: () => {}
            },
            mapPoints: {
                type: Object,
                default: () => {}
            },
            viewMode: {
                type: String,
                default: 'view-blocks'
            }
        },
        data() {
            return {
                showMoreBtn: false,
                offersLength: 6,
                formFeedbackVisible: false,
                currentOffer: null,
                showFavoriteWarn: false
            }
        },
        computed: {
            isMobile () {
                return typeof window === 'object' && window.innerWidth < 768
            },

            getData() {
                return this.offersData.data.slice(0, this.offersLength)
            }
        },

        methods: {
            showFormFeedback (offer) {
                this.currentOffer = offer
                this.formFeedbackVisible = true
            },

            hideFeedbackForm () {
                this.currentOffer = null
                this.formFeedbackVisible = false
            },

            paginationHandler (value) {
                this.$emit('paginationHandler', value)
                const el = document.querySelector('.view-mode-tabs');
                if (el) scrollIt(el, 500);
            },

            showMoreHandler () {
                const pageStep = this.offersData.nav.NavPageSize

                const currentPage = this.offersData.nav.NavPageNomer
                const nextPage = currentPage + 1

                if (nextPage === this.offersData.nav.NavPageCount) {
                    this.showMoreBtn = false
                }

                this.$emit('paginationHandler', nextPage)
            }
        },
        watch: {
            'offersData' () {
                if (this.offersData.nav.NavPageCount === this.offersData.nav.NavPageNomer) {
                    this.showMoreBtn = false
                }
            }
        },
        mounted() {
            if (this.offersData.nav.NavPageCount === this.offersData.nav.NavPageNomer) {
                this.showMoreBtn = false
                return
            }

            if (this.isMobile) {
                this.showMoreBtn = true
                this.offersLength = this.offersData.nav.NavPageCount * this.offersLength
            }
        }
    }
</script>